import schedulingList from "./list"
import schedulingDetails from "./details"
let a = Object.assign({ schedulingList, schedulingDetails });
export default a;